// extracted by mini-css-extract-plugin
export default {"periodInfo":"ChartContainer_periodInfo__AkWVZ","chart":"ChartContainer_chart__qtv7o"};